import {
  call, select, put, delay,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Idx from 'idx';
import { showLoader, hideLoader } from '../actions/app-actions-types';
import { logoutSuccess, setAuthenticationToken } from '../actions/user-action-types';
import axiosInstance from '../utilities/axios-instance';

function* HttpClient(payload, isLoader = true, authorization = true) {
  if (!navigator.onLine) {
    return {
      error: true,
      result: null,
    };
  }

  if (isLoader) {
    yield put(showLoader());
    yield delay(250);
  }
  const data = { ...payload };

  if (authorization) {
    const authToken = yield select(({ user: { token } }) => token);

    if (authToken) {
      data.headers = { 'x-authorization': authToken };
    } else {
      yield put(hideLoader());
      return {
        error: true,
        result: null,
      };
    }
  }

  try {
    const {
      data: result,
      headers: { 'x-authorization': authentication = '' },
    } = yield call(axiosInstance, data);

    yield put(hideLoader());

    if (authentication) {
      yield put(setAuthenticationToken(authentication));
    }

    return {
      error: null,
      result,
    };
  } catch (error) {
    yield put(hideLoader());

    if (Idx(error, (_) => _.code)) {
      if (error.code === 'ECONNABORTED') {
        const message = 'Please try later our servers are not responding.';

        toast.error(message);
      } else if (error.code === 401) {
        yield delay(250);
        yield put(logoutSuccess());
        toast.error(error.message);
      } else if (error.code === 402) {
        // show nothing
      } else {
        toast.error(error.message);
      }
    } else {
      toast.error(error.message);
    }

    return {
      error,
      result: null,
    };
  }
}

export default HttpClient;
